/* eslint-disable jsx-a11y/anchor-is-valid */
/* global Cookies */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';

import FollowersList from './FollowersList';

class ChannelFollowers extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.urls = {
            isFollowing: `/api/channels/${props.slug}/is_following/`,
            followers: `/api/channels/${props.slug}/followers/?page_size=100`,
            changeFollowStatus: `/api/channels/${props.slug}/follow/`,
        };

        this.state = {
            followed: false,
            followers: [],
            followersCount: 0,
            shouldShowModal: false,
        };
    }

    componentDidMount() {
        this.getIsFollowed();
        this.getFollowers();
    }

    getIsFollowed = () => {
        $.ajax({
            url: this.urls.isFollowing,
            success: ({ is_following: isFollowing }) => {
                this.setState({
                    followed: isFollowing,
                });
            },
        });
    };

    getFollowers = () => {
        $.ajax({
            url: this.urls.followers,
            success: ({ results, count = 0 }) => {
                this.setState({
                    followers: results,
                    followersCount: count,
                });
            },
        });
    };

    getFollowersCountLabel = () => {
        const { followersCount } = this.state;
        if (!followersCount) return 'Be the first to follow';

        return `${followersCount} follower${followersCount === 1 ? '' : 's'}`;
    };

    showModal = () => {
        this.setState({
            shouldShowModal: true,
        });
    };

    hideModal = () => {
        this.setState({
            shouldShowModal: false,
        });
    };

    handleClick = () => {
        const httpMethod = this.state.followed ? 'DELETE' : 'POST';

        $.ajaxSetup({
            beforeSend(xhr) {
                xhr.setRequestHeader('X-CSRFToken', Cookies.get('csrftoken'));
            },
        });

        $.ajax({
            url: this.urls.changeFollowStatus,
            type: httpMethod,
            success: () => {
                this.setState((prevState) => ({
                    followed: !prevState.followed,
                }));
                this.getFollowers(); // refresh followers
            },
        });
    };

    renderModal = () => (
        <div
            className="modal"
            id="followers-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="followers-modal"
            aria-hidden="true"
            style={{ zIndex: 11001, display: 'block', background: 'rgba(0,0,0,0.5)' }}
        >
            <div className="modal-dialog" style={{ transform: 'translateY(50%)' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myModalLabel">
                            {this.props.title} followers
                        </h5>
                        <button type="button" className="close" aria-label="Close" onClick={this.hideModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div style={{ overflowY: 'auto' }}>
                            <FollowersList followers={this.state.followers} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" onClick={this.hideModal}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const btnClassNames = classNames('vm-button vm-button--xs', `btn-follow-${this.props.slug}`, {
            'vm-button--primary': !this.state.followed,
            'vm-button--secondary': this.state.followed,
        });

        return (
            <>
                <div className="follow-button">
                    <button
                        type="button"
                        className={btnClassNames}
                        data-tooltip-id="follow-button-tooltip"
                        onClick={this.handleClick}
                    >
                        <i className={this.state.followed ? 'icon icon-check' : 'icon icon-plus'} />
                        {this.state.followed ? 'Following' : 'Follow'}
                    </button>
                    <Tooltip
                        id="follow-button-tooltip"
                        place="top"
                        type="dark"
                        effect="solid"
                        disable={this.state.followed}
                    >
                        {`If you follow ${this.props.title}, you will receive a notification when new content is posted to VuMedi. Click Follow to start.`}
                    </Tooltip>
                    <a href="#" onClick={this.showModal}>
                        {this.getFollowersCountLabel()}
                    </a>
                </div>
                {this.state.shouldShowModal && this.renderModal()}
            </>
        );
    }
}

export default ChannelFollowers;
